import { render, staticRenderFns } from "./modal-step-item.vue?vue&type=template&id=24677d01&"
import script from "./modal-step-item.vue?vue&type=script&lang=js&"
export * from "./modal-step-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports